import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { useAppDispatch } from '../../hooks/useAppDipatch';
import { useAppSelector } from '../../hooks/useAppSelector';
import { setCreationStep } from '../../features/campaigns/campaignsSlice';
import { AuthController } from '../../api/controllers/auth.controller';
import { FairdayLogo } from '../Brand/FairdayLogo';

export interface NavigationItem {
  label: string;
  icon: React.ReactNode;
  href: string;
  id: string;
}

interface NavigationProps {
  items: NavigationItem[];
  currentTab: string;
}

export default function DesktopNav({ items, currentTab }: NavigationProps) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();
  const userId = useAppSelector((state) => state.auth.user?.id);

  const handlePrefetch = (itemId: string) => {
    if (itemId === 'api' && userId) {
      queryClient.prefetchQuery({
        queryKey: ['partnerApiKey', userId],
        queryFn: () => AuthController.getAPIKey(),
        staleTime: 30 * 60 * 1000,
      });
    }
  };

  return (
    <nav className="hidden lg:block w-64 glass-panel p-4">
      <div className="flex items-center px-2 mb-8">
        <FairdayLogo className="h-[60px] w-auto" color="white" />
      </div>
      <div className="space-y-1">
        {items.map((item) => (
          <button
            key={item.label}
            className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg transition-colors ${
              currentTab === item.id
                ? 'bg-accent/10 text-accent'
                : 'text-neutral-light hover:bg-brand-hover'
            }`}
            onMouseEnter={() => handlePrefetch(item.id)}
            onClick={() => {
              navigate(item.href);
              if (item.id === 'campaigns') {
                dispatch(setCreationStep('none'));
              }
            }}
          >
            <div className={currentTab === item.id ? 'text-accent' : 'text-text-muted'}>
              {item.icon}
            </div>
            <span className="font-medium">{item.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
}
